import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.JigsawPuzzle;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "JigsawPuzzle.Phaser.IntroductionScene.1",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/JigsawPuzzleGame/scenes/GameIntro.ts